var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 27,
    fill: "#277FE7",
    stroke: "#F7F8F9",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1978 33.84C27.4778 32.7733 28.4978 31.8867 29.2578 31.18C30.0178 30.46 30.6511 29.7133 31.1578 28.94C31.6645 28.1667 31.9178 27.4067 31.9178 26.66C31.9178 25.98 31.7578 25.4467 31.4378 25.06C31.1178 24.6733 30.6245 24.48 29.9578 24.48C29.2911 24.48 28.7778 24.7067 28.4178 25.16C28.0578 25.6 27.8711 26.2067 27.8578 26.98H25.1378C25.1911 25.38 25.6645 24.1667 26.5578 23.34C27.4645 22.5133 28.6111 22.1 29.9978 22.1C31.5178 22.1 32.6845 22.5067 33.4978 23.32C34.3111 24.12 34.7178 25.18 34.7178 26.5C34.7178 27.54 34.4378 28.5333 33.8778 29.48C33.3178 30.4267 32.6778 31.2533 31.9578 31.96C31.2378 32.6533 30.2978 33.4933 29.1378 34.48H35.0378V36.8H25.1578V34.72L26.1978 33.84Z",
    fill: "#F7F8F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.44075676281a98f1135f8470b3211561.svg";
export { ForwardRef as ReactComponent };